<template>
  <ul class="documents" v-if="getCustomerDocuments.length > 0">
    <li v-for="doc in getCustomerDocuments" :key="doc.identifier" class="document"
           :id="doc.identifier"><a :href="doc.url" @click.prevent="downloadDocument(doc.url, (prefix || 'Dokument') + dateFormatter(doc.date) + '.pdf')" class="document env">{{prefix}}
        vom {{dateFormatter(doc.date)}}</a>
    </li>
  </ul>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import FileSaver from 'file-saver'

export default {
  name: 'CustomerDocumentList',
  computed: {
    getCustomerDocuments () {
      return this.documents || []
    },
    ...mapGetters([
      'accessToken'
    ])
  },
  data () {
    return {}
  },
  props: ['documents', 'prefix'],
  methods: {
    dateFormatter (date) {
      return this.$config.calendar.formatter.dateFormatter.format(new Date(date))
    },
    downloadDocument (url, filename = 'file.pdf') {
      const me = this

      axios.get(url, {
        baseURL: this.$config.apiUrl || '',
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
          Accept: 'application/pdf'
        },
        responseType: 'blob'
      }).then((response) => {
        const file = new Blob([response.data], { type: response.headers['content-type'] })
        FileSaver.saveAs(file, filename)
      }).catch((reason) => {
        me.$store.commit('addError', 'Fehler beim Abrufen der Datei. (' + reason.response.status + ')')
      })
    }
  }
}
</script>
